export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-secondary-50">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20abstract%20atmosphere%20with%20warm%20golden%20and%20amber%20light%20rays%20streaming%20through%20a%20darkened%20theater%20space%2C%20soft%20bokeh%20effects%2C%20elegant%20movie%20watching%20ambiance%2C%20minimal%20composition%2C%20rich%20dark%20warm%20tones%2C%20texture%20of%20velvet%20curtains%20in%20background&width=1600&height=1000&seq=hero-bg-cinema&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-25"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/40 via-transparent to-background-50/90"></div>

      <div className="relative w-full px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 mb-4 text-xs font-medium text-primary-700 bg-primary-100 rounded-full">
              每日更新 · 高清不卡顿
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-foreground-950 leading-tight">
              色影视
              <span className="block text-primary-600 mt-1">高清影视免费在线观看平台</span>
            </h1>

            <p className="mt-3 text-base md:text-lg text-foreground-500 font-medium max-w-xl mx-auto lg:mx-0">
              海量资源 · 极速加载 · 全程免费
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              色影视作为专业的免费在线影视平台，汇聚了海量高清电影、热门电视剧、综艺动漫等优质内容。资源库每日更新，覆盖国内外最新上映的热门影片与经典作品，无需注册登录即可流畅观看。本站致力于为影迷提供不缓冲、不卡顿的高品质观影体验，春色影视最新网址入口持续更新，确保您随时畅享精彩内容。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-600 font-heading">20000+</div>
                <div className="text-xs text-foreground-500 mt-1">影视资源</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-600 font-heading">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">新片速递</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-secondary-700 font-heading">全端适配</div>
                <div className="text-xs text-foreground-500 mt-1">手机电脑平板</div>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                开始观看
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto px-8 py-3.5 border-2 border-primary-300 text-primary-700 font-semibold text-sm rounded-full hover:bg-primary-50 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                下载客户端
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] lg:aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20warm%20golden%20lighting%2C%20film%20reel%20and%20clapperboard%20elements%20floating%20elegantly%2C%20soft%20dramatic%20shadows%2C%20luxury%20home%20theater%20atmosphere%2C%20rich%20amber%20and%20deep%20burgundy%20accents%2C%20artistic%20composition%20with%20negative%20space%2C%20premium%20cinema%20aesthetic&width=800&height=600&seq=hero-visual-cinema&orientation=landscape"
                alt="色影视高清观影体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}